import Paragraph from '@intercom/embercom-composer/blocks/types/paragraph';
import Constants from '@intercom/embercom-composer/lib/constants';
import HtmlEscaper from '@intercom/embercom-composer/lib/html-escaper';
import { hasNativeEmojiSupport, replaceUnicodeWithColonified } from '@intercom/embercom-composer/lib/intermoji';
export default function textToBlocks(text, config) {
  let blocks = [];
  text = text.replace(/\r/g, '');
  text = HtmlEscaper.escape(text);
  if (config.get('allowEmoji') && !hasNativeEmojiSupport()) {
    text = replaceUnicodeWithColonified(text);
  }
  text = text.replace(Constants.ZERO_WIDTH_SPACE_GLOBAL_REGEX, '');
  let paragaphs = text.split(Constants.NEW_LINE + Constants.NEW_LINE);
  paragaphs.forEach(function (paragraph) {
    blocks.pushObject(Paragraph.create({
      config,
      text: paragraph
    }));
  });
  return blocks;
}